<ui-panel class="hearing-history-panel" width="fill" [appTerminologyIdentity]="sectionUsage.heading" [panelTitle]="sectionText.heading()" [title]="sectionText.heading()">
  <p *ngIf="isLoading()" class="hearing-history-panel__state" data-testid="loading-state">Loading hearing history…</p>

  <p *ngIf="hasError()" class="hearing-history-panel__state hearing-history-panel__state--error" data-testid="error-state">
    Hearing history is temporarily unavailable.
  </p>

  <p *ngIf="isEmpty()" class="hearing-history-panel__state" data-testid="empty-state">No prior hearings on file.</p>

  <div class="hearing-history-panel__table-wrap" *ngIf="!isLoading() && !hasError() && entries().length > 0">
    <table class="hearing-history-table" data-testid="hearing-table">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Type</th>
          <th scope="col">Decision</th>
          <th scope="col">Panel</th>
          <th scope="col">Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of entries()">
          <td class="hearing-history-table__date">{{ entry.hearingDate | date: "MM/dd/yyyy" }}</td>
          <td class="hearing-history-table__supporting">{{ entry.hearingType }}</td>
          <td>
            <span
              *ngIf="entry.decisionCode"
              class="hearing-history-table__decision"
              [attr.data-tone]="decisionTone(entry.decisionCode)"
            >{{ decisionLabel(entry.decisionCode) }}</span>
            <span *ngIf="!entry.decisionCode">—</span>
          </td>
          <td class="hearing-history-table__supporting">{{ entry.panelSummary || "—" }}</td>
          <td class="hearing-history-table__notes">{{ entry.notes || "—" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ui-panel>
